import type {FC} from "react"

import {ArrowButton, LinkButton} from "components/button"
import {DescriptionModal} from "components/modal"
import {SmallText} from "components/SmallText"
import {useModal} from "lib/hooks"

interface ModalButtonProps {
  title: string
  description: any // TODO: find type for DatoCMS content
  buttonStyle?: "arrow" | "link"
  className?: string
}

export const GlossaryButton: FC<ModalButtonProps> = ({
  title,
  description,
  buttonStyle = "arrow",
  className
}) => {
  const Button = buttonStyle === "arrow" ? ArrowButton : LinkButton

  const [modal, showModal] = useModal(({isOpened, close}) => (
    <DescriptionModal title={title} isOpened={isOpened} close={close}>
      <SmallText data={description} />
    </DescriptionModal>
  ))

  return (
    <>
      <Button onClick={showModal} className={className}>
        {title}
      </Button>
      {modal}
    </>
  )
}
